// extracted by mini-css-extract-plugin
export default {"search":"styles_search__Cbr4D","search__title":"styles_search__title__bBIof","search__wrapper":"styles_search__wrapper__7syvh","search__submit":"styles_search__submit__FE0gb"};